import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import  Home  from "./components/Home";
import Login from "./components/Login";
import Users from "./components/Managments/Users";
import User from "./components/Managments/User";
import Customers from "./components/Customers";
import Customer from "./components/Customer";
import Services from "./components/Services";
import Service from "./components/Service";
import Contracts from "./components/Contracts";
import Contract from "./components/Contract";
import Documents from "./components/Documents";
import Document from "./components/Document";
import Tasks from "./components/Tasks";
import Task from "./components/Task";
import Dashboard from "./components/Dashboard";
import TaskCalendar from "./components/TaskCalendar";

import LegalObligationTemplates from "./components/LegalObligationTemplates";
import LegalObligationTemplate from "./components/LegalObligationTemplate";
import PersonnelProductivityReport from "./components/PersonnelProductivityReport";
import AdvancedDashboard from "./components/AdvancedDashboard";
import AuditLogs from "./components/AuditLogs";
import CalendarView from "./components/CalendarView";
import DashboardPro from "./components/DashboardPro";
import AccessDenied from "./components/AccessDenied";
import ContractPrint from './components/ContractPrint';
import DailyWorkReport from "./components/DailyWorkReport";
import TimeSheetReport from "./components/TimeSheetReport";
import ContractPerformanceReport from "./components/ContractPerformanceReport";
import PersianHolidays from "./components/PersianHolidays";
export default class App extends Component {
  render() {
    return (
      <Layout>
            <Routes>
                <Route exact path='/' element={<Home />} />
                <Route path='/login' element={<Login />} />

                <Route path='/user/new' element={<User Id={0} />} />
                <Route path='/user/edit/:id' element={<User Id={1} />} />
                <Route path='/users' element={<Users />} />

                <Route path='/customers' element={<Customers />} />
                <Route path='/customer/new' element={<Customer Id={0} />} />
                <Route path='/customer/edit/:id' element={<Customer Id={1} />} />
                <Route path='/services' element={<Services />} />
                <Route path='/service/new' element={<Service Id={0} />} />
                <Route path='/service/edit/:id' element={<Service Id={1} />} />

                <Route path='/contracts' element={<Contracts />} />
                <Route path='/contract/new' element={<Contract Id={0} />} />
                <Route path='/contract/edit/:id' element={<Contract Id={1} />} />


                <Route path='/documents' element={<Documents />} />
                <Route path='/document/new' element={<Document Id={0} />} />
                <Route path='/document/edit/:id' element={<Document Id={1} />} />

                <Route path='/tasks' element={<Tasks />} />
                <Route path='/task/new' element={<Task Id={0} />} />
                <Route path='/task/edit/:id' element={<Task Id={1} />} />


                <Route path='/dashboard' element={<Dashboard />} />
                <Route path='/taskcalendar' element={<TaskCalendar />} />

                <Route path='/legalobligationtemplates' element={<LegalObligationTemplates />} />
                <Route path='/legalobligationtemplate/new' element={<LegalObligationTemplate Id={0} />} />
                <Route path='/legalobligationtemplate/edit/:id' element={<LegalObligationTemplate Id={1} />} />


                <Route path='/reports/productivity' element={<PersonnelProductivityReport />} />
                <Route path='/advanced-dashboard' element={<AdvancedDashboard />} />

                <Route path='/audit-logs' element={<AuditLogs />} />
                <Route path='/calendar' element={<CalendarView />} />
                <Route path='/dashboard-pro' element={<DashboardPro />} />
                <Route path='/access-denied' element={<AccessDenied />} />
                <Route path='/contract/print/:id' element={<ContractPrint />} />

                <Route path='/reports/daily-work' element={<DailyWorkReport />} />
                <Route path='/reports/timesheet' element={<TimeSheetReport />} />
                <Route path='/reports/contract-performance' element={<ContractPerformanceReport />} />

                <Route path='/holidays' element={<PersianHolidays />} />
        </Routes>
      </Layout>
    );
  }
}